define('modules/page_listing/views/limitNoticeView',['require','exports','module','base/layout','env','services/auth','ldsh!../templates/limit_notice'],function (require, exports, module) {
  'use strict';

  const Layout = require('base/layout'),
    config = require('env'),
    Auth = require('services/auth'),
    authInfo = Auth.getAuthInfo();

  const LimitNoticeView = Layout.extend({
    template: require('ldsh!../templates/limit_notice'),

    initialize: function (options) {
      options = options || {};
      const percentage = options.percentage || 0;
      this.percentage = percentage;
    },

    getAdviseTypeByPercentage: function () {
      var adviseType = 'info';

      if (this.percentage >= 70) {
        adviseType = 'warning';
      }

      if (this.percentage >= 90) {
        adviseType = 'danger';
      }

      return adviseType;
    },

    helpers: function () {
      return {
        paymentsUrl: config.paymentsUrl,
        companyId: authInfo.getCompanyId(),
        percentage: this.percentage,
        adviseType: this.getAdviseTypeByPercentage(),
      };
    },

    onRender: function () {
      this.$el.i18n();
    },
  });

  module.exports = LimitNoticeView;
});

